import * as React from "react";

import { asyncWithLDProvider } from "launchdarkly-react-client-sdk";
import ReactDOM from "react-dom";

import { getAptConfig } from "client/config";
import { initializeAmplitude } from "client/lib/amplitude";
import { initializeSentry } from "client/lib/sentry";

import { App } from "./App";
import { GENERIC_ERROR, LD_REDESIGN_REDIRECT } from "./constants";
import { errorActions } from "./store/errorSlice";
import { store } from "./store/initStore";
import { getClientId } from "./utils/session";

const clientId = getClientId();

window?.addEventListener("error", (event: ErrorEvent) => {
  if (process.env.NODE_ENV === "development") {
    console.log("window error: ", event);
  }
  store.dispatch(errorActions.setError(GENERIC_ERROR));
});

window?.addEventListener(
  "unhandledrejection",
  (event: PromiseRejectionEvent) => {
    if (process.env.NODE_ENV === "development") {
      console.log("unhandledrejection: ", event);
    }
    store.dispatch(errorActions.setError(GENERIC_ERROR));
  }
);

// used by legacy to ensure users who land here via LD always end up here
localStorage?.setItem(LD_REDESIGN_REDIRECT, "true");

initializeAmplitude({ clientId });
initializeSentry({ client_id: clientId });

(async () => {
  const LDProvider = await asyncWithLDProvider({
    clientSideID: getAptConfig("LAUNCHDARKLY_KEY"),
    user: {
      kind: "user",
      key: clientId,
      email: localStorage["email"],
    },
    options: {
      disableSyncEventPost: true,
    },
  });

  ReactDOM.render(
    <LDProvider>
      <App />
    </LDProvider>,
    document.getElementById("root")
  );
})();
